// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._16qs1cd0{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}\n._18m915vq{overflow-y:hidden}\n._1pbyowjs{z-index:300}\n._1reo15vq{overflow-x:hidden}\n._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}", ""]);
// Exports
module.exports = exports;
